
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='title'>Das ist bei Gefahrenkarten ausserdem zu beachten</div>
    <p>{`Gefahrenkarten können sich über die Zeit verändern. Wird in einem Bereich zum Beispiel ein Hochwasserschutzprojekt realisiert, kann das dazu führen, dass ein Gefahrengebiet herabgestuft oder ganz gestrichen wird. Dank neuer Messtechniken ist es aber auch möglich, dass neue Gebiete plötzlich als gefährdet erkannt werden. Noch bis vor wenigen Jahren wurden Gutachten zu Naturgefahren vor allem mittels Expertenbegehungen vor Ort gemacht. Inzwischen werden auch Computermodelle beigezogen.`}</p>
    <p>{`Keinen Einfluss auf die Einteilung nach Gefährdungsstufen hat die Nutzung eines Grundstücks. Auch spezifische Schutzmassnahmen nur für ein bestimmtes Gebäude beeinflussen die Einteilung nicht.`}</p>
    <p>{`Die schweizweite Gefahrenkarte von Tamedia basiert auf den gegenwärtig verfügbaren Gefahrenkarten der Kantone. Schutzbauten, für die in der Regel die Gemeinden zuständig sind, fliessen teilweise mit einigen Jahren Verzögerung in die Karte ein. Es ist also möglich, dass in der hier vorliegenden Karte einzelne Gefahrenzuordnungen nicht mehr aktuell sind, weil die Kantone Änderungen noch nicht veröffentlicht haben.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;